import {
  BulkModalAction,
  BulkModalActionType,
} from '../types/conversationsBulkModal.types';

/**
 * Transforms the request_input from the response of an API bulk action, to the
 * format used internally in the bulk actions modal.
 *
 * This is useful for retrying a previous bulk action with the same parameters,
 * using the same mechanism as the modal does when you do it manually.
 */
export const transformBulkActionRequestInputToAction = (
  type: BulkModalActionType,
  csids: number[],
  requestInput: any,
): BulkModalAction | undefined => {
  switch (type) {
    case 'add_internal_note':
      return {
        type,
        arg: {
          csids,
          text: requestInput?.message,
        },
        isValid: true,
      };

    case 'add_tag':
    case 'remove_tag':
      return {
        type,
        arg: {
          action: type,
          csids,
          names: requestInput?.tag_names,
        },
        isValid: true,
      };

    case 'cancel_csat':
    case 'close':
      return {
        type,
        arg: {
          csids,
        },
        isValid: true,
      };

    case 'send_reply':
      return {
        type,
        arg: {
          csids,
          plainText: requestInput?.plain_text,
          htmlText: requestInput?.html_text,
        },
        isValid: true,
      };

    case 'transfer_to_queue':
      return {
        type,
        arg: {
          csids,
          queueId: requestInput?.new_queue_id,
        },
        isValid: true,
      };

    case 'link':
      return {
        type,
        arg: {
          csids,
          link_type: requestInput.link_type,
          parent_csid: requestInput.parent_csid,
        },
        isValid: true,
      };
  }
};
